#no-data-warning{color:#e45454}.no-data{margin-top:5rem}
/*# sourceMappingURL=no-available-data.component-BFZK4GIG.css.map */
